import React from 'react';
import * as S from './styles';
const FooterDisclaimer = React.memo(({ disclaimer }) => (React.createElement(S.Disclaimer, { dangerouslySetInnerHTML: { __html: disclaimer }, "data-testid": "footer-disclaimer" })));
FooterDisclaimer.displayName = 'FooterDisclaimer';
export default FooterDisclaimer;
//# sourceMappingURL=index.js.map